var render, staticRenderFns
import script from "./advance-table.vue?vue&type=script&lang=js"
export * from "./advance-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521c50ab",
  null
  
)

export default component.exports